import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { StyledLogo, StyledOverlay, StyledShadow } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
		<StyledOverlay />
		<StyledShadow />
		<StyledLogo />
	</Fragment>
);

export { Background };
